export default __webpack_public_path__ + "static/media/minilogo.d2237c90.png";